@if (cameras?.length) {
  <ion-list>
    @for (c of cameras; let i = $index; track i) {
      <ion-item lines="none">
        <ion-label>{{ c.name }}</ion-label>
        <ion-button color="danger" (click)="removeCamera(c, i)" fill="clear">
          {{'Remove' | translate}}
        </ion-button>
      </ion-item>
    }
  </ion-list>
}

<ion-button (click)="showAddCamera = !showAddCamera" expand="block" fill="clear" shape="round">
  @if (showAddCamera) {
    {{'Hide Add device' | translate}}
  } @else {
    {{'Add Device' | translate}}
  }
</ion-button>

@if (showAddCamera) {
  <ion-list-header color="light">
    <ion-label>{{'Add Facility' | translate}}</ion-label>
  </ion-list-header>

  <ion-textarea label="Token" labelPlacement="floating" [autoGrow]="true" [(ngModel)]="token" required placeholder="Paste token here"></ion-textarea>

  <ion-button class="ion-margin" (click)="saveToken()" expand="block">
    {{'Save' | translate}}
  </ion-button>
}